import { useForm } from 'react-hook-form';
import { IFilterFleet } from '../../types/interface';
import Card from '../Reusable/Card';
import ComboboxFilter from '../Reusable/ComboboxFilter';
import DateRangePicker from '../Reusable/DateRangeField';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import APIS from '../../constant/Endpoint';

export default function Filter({ control, setValue, getValues }) {
  return (
    <div>
      <Card title='Filter'>
        <div className={tw`grid grid-cols-3 gap-2`}>
          <ComboboxFilter<IFilterFleet>
            label='Status'
            queryKey='status'
            control={control}
            name='status'
            params={{
              is_active: true,
            }}
            url={`${APIS.TICKET}available-status/`}
          />
          <ComboboxFilter<IFilterFleet>
            label='Priority'
            queryKey='priority'
            control={control}
            name='priority'
            params={{
              is_active: true,
            }}
            url={`${APIS.TICKET}available-priority/`}
          />
          <DateRangePicker<IFilterFleet>
            setValue={setValue}
            getValues={getValues}
            name='created__range'
            label='Select Date Range'
          />
        </div>
      </Card>
    </div>
  );
}
